import iconographyImageA from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-a.png";
import iconographyImageB from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-b.png";
import iconographyImageC from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-c.png";
import iconographyImageD from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-d.png";
import iconographyImageE from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-e.png";
import iconographyImageF from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-f.png";
import iconographyImageG from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-g.png";
import iconographyImageH from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-h.png";
import iconographyImageI from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-i.png";
import iconographyImageJ from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-j.png";
import iconographyImageK from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-k.png";
import iconographyImageL from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-l.png";
import iconographyImageM from "../../../../src/pages/whats-new/building-atlassians-new-icon-system/_images/iconography-image-m.png";
import SectionMessage from '@atlaskit/section-message';
import Link from '@atlaskit/link';
import * as React from 'react';
export default {
  iconographyImageA,
  iconographyImageB,
  iconographyImageC,
  iconographyImageD,
  iconographyImageE,
  iconographyImageF,
  iconographyImageG,
  iconographyImageH,
  iconographyImageI,
  iconographyImageJ,
  iconographyImageK,
  iconographyImageL,
  iconographyImageM,
  SectionMessage,
  Link,
  React
};